<template>
  <div class="app-container">
    <div class="head-container">
      <el-button type="primary" icon="el-icon-search" size="small" @click="loadList">刷新</el-button>
      <span style="margin-left:12px;color:#909399;font-size:13px;">
        目前固定 4 种手柄：黑色普通 / 白色普通 / 银色柱状 / 黄球式，可维护图片
      </span>
    </div>

    <el-table v-loading="loading" :data="list" size="small" border style="width:100%;margin-top:12px;">
      <el-table-column prop="handleCode" label="编码" width="140" />
      <el-table-column prop="handleName" label="手柄名称" min-width="120" />
      <el-table-column label="手柄图" width="100" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.handleImage"
            :src="toFullUrl(scope.row.handleImage)"
            :preview-src-list="[toFullUrl(scope.row.handleImage)]"
            fit="contain"
            style="width:56px;height:56px;"
          />
          <span v-else style="color:#c0c4cc;">未上传</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="72" align="center" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
            {{ scope.row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openForm(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="编辑手柄" :visible.sync="formVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" label-width="100px" size="small">
        <el-form-item label="手柄编码">
          <el-input v-model="form.handleCode" disabled />
        </el-form-item>
        <el-form-item label="手柄名称">
          <el-input v-model="form.handleName" maxlength="64" />
        </el-form-item>
        <el-form-item label="手柄图片">
          <admin-single-image-upload v-model="form.handleImage" :width="140" :height="140" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" style="width:100%;" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="formVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AdminSingleImageUpload from '@/pages/admin/components/AdminSingleImageUpload.vue'
import { fetchSealHandles, updateSealHandle } from '@/api/h5-admin-seal-stock'

export default {
  name: 'H5AdminSealHandle',
  components: { AdminSingleImageUpload },
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      formVisible: false,
      form: {
        id: null,
        handleCode: '',
        handleName: '',
        handleImage: '',
        sort: 0,
        status: 1,
        remark: ''
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    toFullUrl(url) {
      if (!url) return ''
      const s = String(url).trim()
      if (/^https?:\/\//i.test(s) || s.startsWith('//') || s.startsWith('data:')) return s
      if (s.indexOf('/upload/') === 0 || s.indexOf('upload/') === 0) {
        return `https://wvxvb.cn/upload/${s.replace(/^\/?upload\/?/, '')}`
      }
      return s
    },
    loadList() {
      this.loading = true
      fetchSealHandles({ page: 0, size: 50 })
        .then((res) => {
          const data = (res && res.data) || {}
          this.list = data.content || []
        })
        .catch(() => {
          this.list = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openForm(row) {
      this.form = {
        id: row.id,
        handleCode: row.handleCode,
        handleName: row.handleName,
        handleImage: row.handleImage || '',
        sort: row.sort != null ? row.sort : 0,
        status: row.status != null ? row.status : 1,
        remark: row.remark || ''
      }
      this.formVisible = true
    },
    submitForm() {
      if (!this.form.handleName) {
        this.$message.warning('请填写手柄名称')
        return
      }
      this.saving = true
      updateSealHandle(this.form)
        .then(() => {
          this.$message.success('已保存')
          this.formVisible = false
          this.loadList()
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
